module.exports = __webpack_public_path__ + "img/personal8.9a8e2be3.png";